import script from "./Access.vue?vue&type=script&lang=ts&setup=true"
export * from "./Access.vue?vue&type=script&lang=ts&setup=true"

import "./Access.vue?vue&type=style&index=0&id=6f3b239f&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f3b239f"]])

export default __exports__